import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
export const useMeta = () => {
  const [m, setM] = useState(cache);
  useEffect(() => { if (!cache) api.get("/api/dir/meta").then(r => { cache = r.data; setM(r.data); }).catch(() => {}); }, []);
  return m;
};

export const useNearMe = () => {
  const [busy, setBusy] = useState(false);
  const locate = () => new Promise((res, rej) => {
    if (!navigator.geolocation) return rej(new Error("Location isn't available in this browser"));
    setBusy(true);
    navigator.geolocation.getCurrentPosition(p => { setBusy(false); res({ lat: p.coords.latitude, lng: p.coords.longitude }); },
      () => { setBusy(false); rej(new Error("Allow location access to see shops near you")); }, { timeout: 10000, maximumAge: 600000 });
  });
  return { busy, locate };
};
